import { TFloorParams, TRoomsParams } from 'common/types/floor-params.type';
import { CUSTOMER_ID_COOKIE_NAME } from 'pages/common/consts/cookies';
import { MAX_ROOMS_LENGTH } from 'pages/common/consts/rooms';
import { getCookie } from 'utils/cookie.helper';
import { getBodyForCalculationStorage } from './get-body-for-calculate-storage.helper';
import { getRoomIdsWithSameInputParams } from './get-room-ids-with-same-input-params';

type TCheckInputParamsInRooms = {
  inputParams: TFloorParams;
  calculatorId: string;
  typeInstallation: string | null;
  rooms: TRoomsParams[];
};

type TResult = {
  needToUpdateRooms: boolean;
  newRooms: TRoomsParams[];
  sameRooms: string[];
};

export const checkInputParamsInRooms = ({
  inputParams,
  calculatorId,
  typeInstallation,
  rooms,
}: TCheckInputParamsInRooms): TResult => {
  const authorizedCustomerId = getCookie(CUSTOMER_ID_COOKIE_NAME);
  const isAuthorized = Boolean(authorizedCustomerId);
  const bodyForNewRoom = getBodyForCalculationStorage({
    inputParams,
    calculatorId,
    typeInstallation,
    isAuthorized,
  });

  const dataInRooms = [...rooms];

  // Проверяем, есть ли среди загруженных комнат данные с такими же параметрами
  const roomIdsWithSameInputParams = getRoomIdsWithSameInputParams({
    dataInRooms,
    inputParams,
    typeInstallation,
  });
  //  если есть, то не сохраняем ничего
  if (roomIdsWithSameInputParams.length > 0) {
    return {
      needToUpdateRooms: false,
      newRooms: [],
      sameRooms: roomIdsWithSameInputParams,
    };
  }

  // Если комнат меньше 3, добавляем новый элемент
  if (dataInRooms.length < MAX_ROOMS_LENGTH) {
    return {
      needToUpdateRooms: true,
      newRooms: rooms.concat(bodyForNewRoom),
      sameRooms: [],
    };
  }
  // если уже три комнаты загружено, то заменяем самый ранний элемент на новый(приоритет - неавторизованные)
  const earliestIndex = dataInRooms.reduce((earliest, current, index) => {
    if (current.isAuthorized && !dataInRooms[earliest].isAuthorized) return earliest;
    if (!current.isAuthorized && dataInRooms[earliest].isAuthorized) return index;
    return new Date(current.createdDate) < new Date(dataInRooms[earliest].createdDate) ? index : earliest;
  }, 0);

  dataInRooms.splice(earliestIndex, 1, bodyForNewRoom);

  return {
    needToUpdateRooms: true,
    newRooms: dataInRooms,
    sameRooms: [],
  };
};
